/**
 * @author       luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright    Copyright (c) 2025, Zumper
 * @description  trackUnloadableTours
 */

import {
  VIRTUAL_TOUR_IMPRESSION_FAILED,
  event,
  getEntityProperties,
} from '@zcode-ui/web-zumper-integrations'
import type { Origin } from '@zcode/nr-utils'
import { selectUser } from '@zcode/nr/es/shared/modules/user/selectors'
import { getRouteProps } from '@zcode/nr/es/shared/packages/history-middleware'
import type { Listable, MaybeEmptyProperty, Pin, RawPinInventorySearch } from '@zcode/state-type'
import { routes } from '@zcode/zumper-routes'
import type { Dispatch, GetState } from '../../../modules/types'
import { getTraktorPageType } from './trackDetailEvent'

interface Props {
  entity: Listable | Pin<RawPinInventorySearch> | MaybeEmptyProperty | null | undefined
  mediaId?: number | undefined
  mediaUrl?: string | null | undefined
  origin: Origin | undefined
  previewUrl?: string | null
}

export const trackUnloadableTours =
  ({ entity, mediaId, mediaUrl, origin, previewUrl }: Props) =>
  (dispatch: Dispatch, getState: GetState) => {
    if (!mediaId && !mediaUrl) {
      return
    }
    const state = getState()
    const user = selectUser(state)
    const entityProperties = entity && getEntityProperties(entity, state)
    const { match } = dispatch(getRouteProps({ routes }))
    const props = {
      origin,
      ...entityProperties,
      pageType: entity && getTraktorPageType(entity, match, state),
      mediaId,
      mediaUrl,
      previewUrl,
    }
    dispatch(event({ name: VIRTUAL_TOUR_IMPRESSION_FAILED, user, props }))
  }
